import { render } from "./ProductGridSection.vue?vue&type=template&id=2946136a&scoped=true"
import script from "./ProductGridSection.vue?vue&type=script&lang=js"
export * from "./ProductGridSection.vue?vue&type=script&lang=js"

import "./ProductGridSection.vue?vue&type=style&index=0&id=2946136a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2946136a"]])

export default __exports__